const vxlColors = {
  core: {
    purple: {
      100: '#ede6fd',
      200: '#dbcef2',
      300: '#cfbbf0',
      500: '#8c58d0',
      600: '#774bb0',
      700: '#67419a',
      900: '#42185f',
    },
    neutrals: {
      white: '#ffffff',
      grey: {
        100: '#f4f6f8',
        200: '#e6eaed',
        300: '#caced3',
        400: '#9fa1a4',
        500: '#767676',
        600: '#6d7176',
      },
      black: '#1c1c1c',
    },
    primary: {
      red: {
        100: '#fad9d2',
        200: '#fecac1',
        300: '#feb2a5',
        500: '#d44326',
        600: '#c2351f',
        700: '#b82d1d',
        900: '#852520',
      },
      yellow: {
        100: '#ffefc6',
        200: '#fee6aa',
        300: '#fee299',
        500: '#f8c33b',
        600: '#f0b435',
        700: '#db9d32',
        900: '#885d14',
      },
      green: {
        100: '#dcf6e6',
        200: '#c9f0d7',
        300: '#ace5c1',
        500: '#1c8757',
        600: '#167a4a',
        700: '#186e44',
        900: '#195836',
      },
    },
    expressive: {
      sky: {
        500: '#d7f5f1',
        600: '#caf1ec',
        700: '#bfede7',
      },
      seafoam: {
        500: '#a4dbd9',
      },
      mint: {
        500: '#5ec496',
      },
      forest: {
        300: '#25503e',
        400: '#204636',
        500: '#183428',
      },
      orchid: {
        500: '#ede6fd',
        600: '#e4d9fc',
        700: '#ddd0fb',
      },
      lavender: {
        500: '#cdb0fa',
      },
      varoPurple: {
        500: '#8c58d0',
        600: '#774bb0',
        700: '#67419a',
      },
      eggplant: {
        500: '#42185f',
      },
      blush: {
        500: '#fadfdc',
        600: '#f8d2ce',
        700: '#f6c6c1',
      },
      coral: {
        500: '#f2a295',
      },
      sunset: {
        500: '#ed6c52',
      },
      wine: {
        500: '#751d18',
      },
      sand: {
        500: '#faefdc',
        600: '#f7e8ce',
        700: '#f4e2c2',
      },
      light: {
        500: '#fdf0af',
        600: '#fcea92',
        700: '#fae57a',
      },
      lime: {
        500: '#d4e84b',
        600: '#cbe326',
        700: '#c1d91c',
      },
      earth: {
        500: '#4a4216',
      },
    },
  },
};

export default vxlColors;
